import 'init';

import React from 'react';
import ReactDOM from 'react-dom';

import $ from 'jquery';
import * as singleSpa from 'single-spa';

import * as ClassicApp from 'singlespa/apps/classic';
import * as GammaApp from 'singlespa/apps/gamma';
import Interceptor from 'singlespa/interceptor';

import { Chrome } from 'views/chrome/chrome-view';

// This is a "loading function" Inside of it, the import introduces a code splitting
// point. Webpack will create separate code chunks that will be lazy loaded by single-spa.
const loadGamma = () => Promise.resolve().then(() => GammaApp);
const loadClassic = () => Promise.resolve().then(() => ClassicApp);

// This is an "activity function"
// this is where we'd check for whether this is a classic or gamma url ... rather than use window location
const isGammaActive = () => Interceptor.isGammaRoute(window.location.pathname);
const isClassicActive = () => !isGammaActive();

// Register the application with single-spa
singleSpa.registerApplication('gamma', loadGamma, isGammaActive);
singleSpa.registerApplication('classic', loadClassic, isClassicActive);

$(() => {
  ReactDOM.render(<Chrome />, document.getElementById('classic'));
});



// WEBPACK FOOTER //
// ./app/scripts/entry/app.js